import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';
import ja from './locales/ja.json';
import ptBR from './locales/pt-BR.json';
import zhCN from './locales/zh-CN.json';

/**
 * Loading order:
 * 1. i18next-browser-languagedetector (querystring → localStorage → navigator).
 * 2. Server-provided shop setting (set after mount via `i18n.changeLanguage`).
 *
 * Missing keys fall back to English — the non-English locale files are
 * intentionally partial (high-visibility strings only). The fallback avoids
 * showing raw keys if a translation is missing.
 */
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'es', 'ja', 'pt-BR', 'zh-CN'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
      ja: { translation: ja },
      'pt-BR': { translation: ptBR },
      'zh-CN': { translation: zhCN },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
